import { render, staticRenderFns } from "./RefereeList.vue?vue&type=template&id=f324f20a&"
import script from "./RefereeList.vue?vue&type=script&lang=js&"
export * from "./RefereeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports